import { PayeeRowTinType } from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";
import { validatorCompanyName } from "../../../../../shared/validators/validatorCompanyName";
import { validatorBusinessCompanyStructure } from "../../../../../shared/validators/validatorCompanyStructure";
import { validatorName } from "../../../../../shared/validators/validatorName";
import { validatorTaxId } from "../../../../../shared/validators/validatorTaxId";
import {
  companyNameValidator,
  validatorFirstName,
  validatorLastName
} from "../../../../../utils/validators";
import { getValidationSchemaAddress } from "../../../../../shared/validators/address/validationSchemaAddress";

export const getValidationSchema = (withTaxInfo: boolean) => {
  const validationSchema = Yup.object().shape({
    name: validatorName,
    companyName: companyNameValidator
  });

  if (withTaxInfo) {
    const taxInfoValidationSchema = Yup.object().shape({
      tinType: Yup.string()
        .oneOf([PayeeRowTinType.INDIVIDUAL, PayeeRowTinType.BUSINESS])
        .required("TIN type is required"),
      individual: Yup.object().when("tinType", {
        is: PayeeRowTinType.INDIVIDUAL,
        then: Yup.object()
          .shape({
            firstName: validatorFirstName.required("First name is required"),
            lastName: validatorLastName.required("Last name is required"),
            ssn: validatorTaxId("ssn", "Individual", "US").required(
              "SSN or ITIN is required"
            )
          })
          .required("Individual information is required")
      }),
      business: Yup.object().when("tinType", {
        is: PayeeRowTinType.BUSINESS,
        then: Yup.object()
          .shape({
            legalBusinessName: validatorCompanyName.required(
              "Legal business name is required"
            ),
            ein: validatorTaxId("ein", "Business", "US").required(
              "EIN is required"
            ),
            companyStructure: validatorBusinessCompanyStructure.required(
              "Tax classification is required"
            ),
            disregardedEntityName: validatorCompanyName
          })
          .required("Business information is required")
      }),
      address: getValidationSchemaAddress("US").concat(
        Yup.object().shape({
          country: Yup.string().required("Country is required")
        })
      )
    });

    return validationSchema.concat(taxInfoValidationSchema);
  }

  return validationSchema;
};
